import React, { Component } from 'react';
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom';

import App from "../page/App";
import OpenInfo from "../page/openInfoManage/openInfo/openInfo";
import Error404 from "../page/error/error";
import Login from "../page/login/login";
import QueryLanding from '../page/query/records/landing/landing';
import QueryOverView from '../page/query/records/overview/overview';
import QueryDetail from '../page/query/records/details/details';
import Ueditor from "../page/AddMessage/AddMessage"
import CaissaOrder from "../page/couponManage/caissa/orderList/orderList";
import BaichengQuery from "../page/query/baichengQuery/baichengQuery";
import BaichengUserCensus from "../page/query/baichengUserCensus/baichengUserCensus";
import UserFromCensus from "../page/query/userFromCensus/userFromCensus";
import leActivity from "../page/leActivityManage/publishActivity/publishActivity";
import leRules from "../page/leActivityManage/publishRules/publishRules";
import LiveInfoList from "../page/liveInfoList/liveInfoList";
import LiveActivity from "../page/liveActivity/liveActivity";
import SensitiveWords from "../page/sensitiveWords/sensitiveWords";

import ChatSensitiveWordsList from "../page/chatSensitiveWords/list/list";
import ChatSensitiveWordsDetail from "../page/chatSensitiveWords/detail/detail";

import TreasureHuntUserRule from "../page/treasureHunt/userRule/userRule";

import ThemeFlightShopList from "../page/themeFlight/list/list";
import ThemeFlightShopDetail from "../page/themeFlight/shopDetail/shopDetail";

import TourStatistical from "../page/tourStatistical/tourStatistical";
import RailStatistical from "../page/railStatistical/railStatistical";

import couponsAdd from "../page/coupons/add/add";

import winterGamesAnswer from "../page/winterGamesAnswer/winterGamesAnswer";
import liveDraw from "../page/liveDraw/liveDraw";

import alipayTransfer from "../page/cashManagement/alipayTransfer/alipayTransfer";

import MusicList from "../page/music/list";
import MusicEdit from "../page/music/addOrEdit";
import MusicManage from "../page/music/manage";
import MusicAdd from "../page/music/manage/add";

import BrokerList from "../page/insuranceBroker/brokerList";
import InvitationList from "../page/insuranceBroker/invitationList";
import SharonList from "../page/insuranceBroker/sharonList";
import ParticipantsList from "../page/insuranceBroker/participantsList";
import CardList from "../page/coupons/cardList";
import CardAdd from "../page/coupons/cardAdd";
import TicketStatistics from "../page/coupons/ticketStatistics";
import Insurance from '../page/ext/insurance';

class RouterComponent extends Component {
    render() {
        return (
            <React.Fragment>
                <Router basename="/crm">
                    <Switch>
                        <Route exact path='/login' component={Login}></Route>
                        <Route exact path='/query/landing' component={QueryLanding}></Route>
                        <Route exact path='/query/overview' component={QueryOverView}></Route>
                        <Route exact path='/query/detail' component={QueryDetail}></Route>
                        <Route exact path='/AddMessage' component={Ueditor}></Route>
                        <Route exact path='/openInfo' component={OpenInfo}></Route>
                        <Route exact path='/leActivity' component={leActivity}></Route>
                        <Route exact path='/leRules' component={leRules}></Route>
                        <Route exact path='/ueditor' component={Ueditor}></Route>
                        <Route exact path='/query/baicheng' component={BaichengQuery}></Route>
                        <Route exact path='/query/baicheng/userCensus' component={BaichengUserCensus}></Route>
                        <Route exact path='/query/userFromCensus' component={UserFromCensus}></Route>
                        <Route exact path='/liveInfoList' component={LiveInfoList}></Route>
                        <Route exact path='/liveActivity' component={LiveActivity}></Route>
                        <Route exact path='/coupon/caissa/orderList' component={CaissaOrder}></Route>
                        <Route exact path='/sensitiveWords' component={SensitiveWords}></Route>
                        <Route exact path='/chatSensitiveWordsList' component={ChatSensitiveWordsList}></Route>
                        <Route exact path='/chatSensitiveWordsDetail' component={ChatSensitiveWordsDetail}></Route>
                        <Route exact path='/treasureHuntUserRule' component={TreasureHuntUserRule}></Route>
                        <Route exact path='/themeFlightShopDetail' component={ThemeFlightShopDetail}></Route>
                        <Route exact path='/ThemeFlightShopList' component={ThemeFlightShopList}></Route>
                        <Route exact path='/tourStatistical' component={TourStatistical}></Route>
                        <Route exact path='/railStatistical/:playId' component={RailStatistical}></Route>
                        <Route exact path='/coupons/add' component={couponsAdd}></Route>
                        <Route exact path='/winterGamesAnswer' component={winterGamesAnswer}></Route>
                        <Route exact path='/liveDraw' component={liveDraw}></Route>
                        <Route exact path='/cashManagement/alipayTransfer' component={alipayTransfer}></Route>
                        <Route exact path='/music/list' component={MusicList}></Route>
                        <Route exact path='/music/addOrEdit' component={MusicEdit}></Route>
                        <Route exact path='/music/manage' component={MusicManage}></Route>
                        <Route exact path='/music/manage/add' component={MusicAdd}></Route>
                        <Route exact path='/insuranceBroker/brokerList' component={BrokerList}></Route>
                        <Route exact path='/insuranceBroker/invitationList' component={InvitationList}></Route>
                        <Route exact path='/insuranceBroker/sharonList' component={SharonList}></Route>
                        <Route exact path='/insuranceBroker/participantsList' component={ParticipantsList}></Route>
                        <Route exact path='/coupons/cardList' component={CardList}></Route>
                        <Route exact path='/coupons/cardAdd' component={CardAdd}></Route>
                        <Route exact path='/coupons/ticketStatistics' component={TicketStatistics}></Route>
                        <Route exact path='/ext/insurance' component={Insurance}></Route>

                        <Route exact path='/' component={App}></Route>
                        <Route path='/error/404' component={Error404}></Route>
                        <Redirect to="/error/404" component={Error404} />
                    </Switch>
                </Router>
            </React.Fragment>
        );
    }
}

export default RouterComponent